import { forwardRef } from "react";
import { Input as AntdInput, type InputProps as AntdInputProps, type InputRef } from "antd";

import type { AvE2EProps } from "@av/components/types";
import { CustomPassword } from "./Password";
import { CustomSearch } from "./Search";
import { CustomTextArea } from "./TextArea";

type InputProps = AntdInputProps & AvE2EProps;

export const CustomInput = forwardRef<InputRef, InputProps>(function CustomInput(props, ref) {
  const { testIdPrefix, ...rest } = props;

  return <AntdInput ref={ref} data-testid={testIdPrefix + "-input"} size="middle" {...rest} />;
});

export const Input = Object.assign(CustomInput, {
  Search: CustomSearch,
  TextArea: CustomTextArea,
  Password: CustomPassword,
});
